import { model as router } from '!/router'
import { createEvent, createStore, sample } from 'effector'
import { PlayerSubRoute as PlayerSubRouteEnum } from '~/shared/interfaces/player/generic'
import type {
  LiveEventUrlParams,
  MovieUrlParams,
  TvChannelUrlParams,
  TvShowEpisodeUrlParams,
  TvShowUrlParams,
} from './index.h'
import {
  generateLiveEventUrl,
  generateMovieUrlParams,
  generateTvShowEpisodeUrlParams,
  generateTvShowUrlParams,
  generateTvUrlParams,
} from './lib'

export const $redirectUrlParams = createStore<string>('', {
  sid: '$redirectUrlParams',
})

export const saveTvChannelRedirectUrl = createEvent<TvChannelUrlParams>()

export const saveMovieRedirectUrl = createEvent<MovieUrlParams>()

export const saveTvShowRedirectUrl = createEvent<TvShowUrlParams>()

export const saveTvShowEpisodeRedirectUrl =
  createEvent<TvShowEpisodeUrlParams>()

export const saveLiveEventRedirectUrl = createEvent<LiveEventUrlParams>()

export const redirectToPlayer = createEvent()

export const redirectToShowPlayer = createEvent()

export const redirectToVodPlayer = createEvent()

export const redirectToTvPlayer = createEvent<string | undefined>()

export const redirectToEventPlayer = createEvent()

export const redirectToHome = createEvent()

sample({
  clock: saveTvChannelRedirectUrl,
  fn: generateTvUrlParams,
  target: $redirectUrlParams,
})

sample({
  clock: saveMovieRedirectUrl,
  fn: generateMovieUrlParams,
  target: $redirectUrlParams,
})

sample({
  clock: saveTvShowRedirectUrl,
  fn: generateTvShowUrlParams,
  target: $redirectUrlParams,
})

sample({
  clock: saveTvShowEpisodeRedirectUrl,
  fn: generateTvShowEpisodeUrlParams,
  target: $redirectUrlParams,
})

sample({
  clock: saveLiveEventRedirectUrl,
  fn: generateLiveEventUrl,
  target: $redirectUrlParams,
})

sample({
  clock: redirectToPlayer,
  source: $redirectUrlParams,
  fn: (urlQueryParamsStr) => {
    const values = new URLSearchParams(urlQueryParamsStr)
    let subRoute = ''

    if (values.has('tvshowId')) subRoute = PlayerSubRouteEnum.SHOW
    if (values.has('liveEventId')) subRoute = PlayerSubRouteEnum.EVENT
    if (values.has('channelId')) subRoute = PlayerSubRouteEnum.TV
    if (values.has('vodId')) subRoute = PlayerSubRouteEnum.VOD
    return `/player/${subRoute}?${urlQueryParamsStr}`
  },
  target: router.navigatePush,
})

sample({
  clock: redirectToShowPlayer,
  source: $redirectUrlParams,
  fn: (params) => `/player/series?${params}`,
  target: router.navigatePush,
})

sample({
  clock: redirectToVodPlayer,
  source: $redirectUrlParams,
  fn: (params) => `/player/movie?${params}`,
  target: router.navigatePush,
})

sample({
  clock: redirectToTvPlayer,
  source: $redirectUrlParams,
  fn: (params, categoryName) => ({
    pathname: `/player/live?${params}`,
    state: categoryName,
  }),
  target: router.navigatePush,
})

sample({
  clock: redirectToEventPlayer,
  source: $redirectUrlParams,
  fn: (params) => `/player/event?${params}`,
  target: router.navigatePush,
})

sample({
  clock: redirectToHome,
  fn: () => `/`,
  target: router.navigatePush,
})
